export default __webpack_public_path__ + "static/medialike-banner-home-31f7bf0f3a49456fd90730d59600a951.png";